var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { ref: "comnSvcInfo", attrs: { model: _vm.comnSvcRequire } },
        [
          _c("div", { staticClass: "simple-form" }, [
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("名称")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "title",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入名称" },
                        model: {
                          value: _vm.comnSvcRequire.title,
                          callback: function($$v) {
                            _vm.$set(_vm.comnSvcRequire, "title", $$v)
                          },
                          expression: "comnSvcRequire.title"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("服务类型")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "servcTypeId",
                        rules: { validator: _vm.checkNull, trigger: "blur" }
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          on: { change: _vm.servcTypeChange },
                          model: {
                            value: _vm.comnSvcRequire.servcTypeId,
                            callback: function($$v) {
                              _vm.$set(_vm.comnSvcRequire, "servcTypeId", $$v)
                            },
                            expression: "comnSvcRequire.servcTypeId"
                          }
                        },
                        _vm._l(_vm.servcTypeList, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.text, value: item.value }
                          })
                        })
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", { staticClass: "required" }, [_vm._v("允许抢单")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "grabIssueAllowed" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.comnSvcRequire.grabIssueAllowed,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.comnSvcRequire,
                                "grabIssueAllowed",
                                $$v
                              )
                            },
                            expression: "comnSvcRequire.grabIssueAllowed"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: true } }, [
                            _vm._v("是")
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: false } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group center" }, [
              _c("div", { staticClass: "form-label" }, [
                _c("label", [_vm._v("描述")])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-value width-2x" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "desc" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入描述"
                        },
                        model: {
                          value: _vm.comnSvcRequire.desc,
                          callback: function($$v) {
                            _vm.$set(_vm.comnSvcRequire, "desc", $$v)
                          },
                          expression: "comnSvcRequire.desc"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("适用机构")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "swb-btn-link",
            on: {
              click: function($event) {
                _vm.selectShop()
              }
            }
          },
          [_vm._v("选择")]
        )
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "body" },
          [
            _vm._l(_vm.appliedShopList, function(item, index) {
              return _vm.appliedShopList.length > 0
                ? _c("tr", { staticClass: "row" }, [
                    _c("td", { staticStyle: { "text-align": "left" } }, [
                      _c("span", [_vm._v(_vm._s(item.comName))])
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c("span", [
                        _vm._v(_vm._s(_vm.getTransComLevel(item.comLevel)))
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticStyle: { "text-align": "center" } },
                      [
                        item.comLevel <= 4
                          ? _c("el-checkbox", {
                              model: {
                                value: item.includeSubComs,
                                callback: function($$v) {
                                  _vm.$set(item, "includeSubComs", $$v)
                                },
                                expression: "item.includeSubComs"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "span",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.removeShop(index)
                            }
                          }
                        },
                        [_vm._v("移除")]
                      )
                    ])
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm.appliedShopList.length <= 0 ? _c("tr", [_vm._m(1)]) : _vm._e()
          ],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c("th", { staticStyle: { "text-align": "left" } }, [
          _vm._v("机构名称")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "120" } }, [_vm._v("机构级别")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "150" } }, [_vm._v("包含下级机构")]),
        _vm._v(" "),
        _c("th", { attrs: { width: "80" } }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: { "text-align": "center", "line-height": "40px" },
        attrs: { colspan: "4" }
      },
      [_c("span", [_vm._v("暂无数据...")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d395b79c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d395b79c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/shopComnReq/ComnSvcRequireSave.vue
// module id = 2376
// module chunks = 0